import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { aiApi } from '@/utils/aiApi';

// ChatGPT model catalogue + the account-wide preference that powers every AI feature.
export const useAiModels = () => {
  const [models, setModels] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    aiApi.models()
      .then((data) => { setModels(data.models); setSelected(data.selected); })
      .catch(() => toast.error('Could not load AI models'))
      .finally(() => setLoading(false));
  }, []);

  const select = useCallback(async (model) => {
    const previous = selected;
    setSelected(model);
    try {
      await aiApi.selectModel(model);
      const name = models.find((m) => m.id === model)?.name || model;
      toast.success(`AI features now use ${name}`);
    } catch (error) {
      setSelected(previous);
      toast.error(error.response?.data?.detail || 'Could not change the model');
    }
  }, [models, selected]);

  const nameOf = useCallback((id) => models.find((m) => m.id === id)?.name || id, [models]);

  return { models, selected, select, loading, nameOf };
};
